// Single source of truth for the API-level error union. Module-namespaced
// codes (`<module>/<reason>`) are added additively by their owning module's
// work unit; module-local errors.ts files only re-export the relevant subset.
// The W17 OpenAPI aggregator asserts httpMap (apps/web/src/server/_platform/
// errors/http-map.ts, owned by W04) remains exhaustive after every change.
export class DomainError extends Error {
    error;
    constructor(error) {
        super(error.code);
        this.error = error;
    }
}
//# sourceMappingURL=errors.js.map